import React, { useState } from 'react';

const Icon = {
  Mail: (props) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-6 h-6" {...props}>
      <rect x="2" y="4" width="20" height="16" rx="2" />
      <path d="M22 6L12 13 2 6" />
    </svg>
  ),
  Phone: (props) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-6 h-6" {...props}>
      <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z" />
    </svg>
  ),
  MapPin: (props) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-6 h-6" {...props}>
      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" />
      <circle cx="12" cy="10" r="3" />
    </svg>
  ),
  Clock: (props) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-6 h-6" {...props}>
      <circle cx="12" cy="12" r="10" />
      <polyline points="12 6 12 12 16 14" />
    </svg>
  ),
  Send: (props) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-5 h-5" {...props}>
      <line x1="22" y1="2" x2="11" y2="13" />
      <polygon points="22 2 15 22 11 13 2 9 22 2" />
    </svg>
  ),
  Check: (props) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="w-5 h-5" {...props}>
      <path d="M20 6L9 17l-5-5" />
    </svg>
  ),
};

export default function Contacto() {
  const [formData, setFormData] = useState({
    nombre: '',
    email: '',
    asunto: '',
    mensaje: '',
  });
  const [enviado, setEnviado] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Aquí iría la lógica para enviar el email
    console.log('Formulario enviado:', formData);
    setEnviado(true);
    setFormData({ nombre: '', email: '', asunto: '', mensaje: '' });
    setTimeout(() => setEnviado(false), 5000);
  };

  return (
    <div className="pt-24 bg-white">
      {/* Hero Section */}
      <section className="relative overflow-hidden bg-gradient-to-b from-brand/5 to-transparent border-b border-brand/20">
        <div className="absolute top-0 right-0 w-96 h-96 bg-gradient-to-br from-brand/10 to-transparent rounded-full blur-3xl -mr-48 -mt-48"></div>
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-gradient-to-tr from-yellow-100/20 to-transparent rounded-full blur-3xl -ml-48 -mb-48"></div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 sm:py-28 lg:py-36 relative z-10">
          <div className="max-w-3xl">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-gradient-to-r from-yellow-50 to-yellow-100 border border-brand/30 mb-6">
              <span className="w-2 h-2 rounded-full bg-brand animate-pulse"></span>
              <span className="text-sm font-bold text-brand-dark tracking-wide">PONTE EN CONTACTO</span>
            </div>
            <h1 className="text-5xl sm:text-6xl lg:text-7xl font-black text-gray-900 leading-[1.1] tracking-tight">
              Hablemos de tu Proyecto
            </h1>
            <p className="mt-6 text-xl sm:text-2xl text-gray-600 leading-relaxed max-w-2xl">
              Estamos aquí para ayudarte. Contacta con nuestro equipo de expertos y descubre cómo podemos potenciar tu tesis.
            </p>
          </div>
        </div>
      </section>

      {/* Contact Info Grid */}
      <section className="py-16 sm:py-20 lg:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-8 mb-16">
            {/* Email */}
            <div className="group">
              <div className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-gradient-to-br from-yellow-100 to-yellow-200 text-brand-dark group-hover:shadow-lg group-hover:shadow-brand/30 transition-all duration-300 mb-4">
                <Icon.Mail />
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">Email</h3>
              <a href="mailto:info@tesis1.pe" className="text-brand-dark hover:text-brand font-medium transition-colors">
                info@tesis1.pe
              </a>
            </div>

            {/* Phone */}
            <div className="group">
              <div className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-gradient-to-br from-yellow-100 to-yellow-200 text-brand-dark group-hover:shadow-lg group-hover:shadow-brand/30 transition-all duration-300 mb-4">
                <Icon.Phone />
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">WhatsApp</h3>
              <a href="https://wa.me/+51983318651" target="_blank" rel="noreferrer" className="text-brand-dark hover:text-brand font-medium transition-colors">
                +51 983 318 651
              </a>
            </div>

            {/* Location */}
            <div className="group">
              <div className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-gradient-to-br from-yellow-100 to-yellow-200 text-brand-dark group-hover:shadow-lg group-hover:shadow-brand/30 transition-all duration-300 mb-4">
                <Icon.MapPin />
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">Ubicación</h3>
              <p className="text-gray-600 font-medium">
                Lima, Perú
              </p>
            </div>

            {/* Hours */}
            <div className="group">
              <div className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-gradient-to-br from-yellow-100 to-yellow-200 text-brand-dark group-hover:shadow-lg group-hover:shadow-brand/30 transition-all duration-300 mb-4">
                <Icon.Clock />
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">Horario</h3>
              <p className="text-gray-600 font-medium">
                Lun - Sáb: 9:00 - 19:00
              </p>
            </div>
          </div>

          <div className="grid lg:grid-cols-2 gap-16">
            {/* Contact Form */}
            <div>
              <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-8">
                Envíanos un Mensaje
              </h2>

              <form onSubmit={handleSubmit} className="space-y-6">
                <div>
                  <label htmlFor="nombre" className="block text-sm font-bold text-gray-900 mb-2">
                    Tu Nombre
                  </label>
                  <input
                    type="text"
                    id="nombre"
                    name="nombre"
                    value={formData.nombre}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 rounded-xl border-2 border-gray-200 focus:border-brand focus:outline-none transition-all duration-200 text-gray-900 placeholder-gray-500 font-medium"
                    placeholder="Juan Pérez"
                  />
                </div>

                <div>
                  <label htmlFor="email" className="block text-sm font-bold text-gray-900 mb-2">
                    Tu Email
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 rounded-xl border-2 border-gray-200 focus:border-brand focus:outline-none transition-all duration-200 text-gray-900 placeholder-gray-500 font-medium"
                    placeholder="juan@ejemplo.com"
                  />
                </div>

                <div>
                  <label htmlFor="asunto" className="block text-sm font-bold text-gray-900 mb-2">
                    Asunto
                  </label>
                  <input
                    type="text"
                    id="asunto"
                    name="asunto"
                    value={formData.asunto}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 rounded-xl border-2 border-gray-200 focus:border-brand focus:outline-none transition-all duration-200 text-gray-900 placeholder-gray-500 font-medium"
                    placeholder="Consultoría sobre mi tesis"
                  />
                </div>

                <div>
                  <label htmlFor="mensaje" className="block text-sm font-bold text-gray-900 mb-2">
                    Mensaje
                  </label>
                  <textarea
                    id="mensaje"
                    name="mensaje"
                    value={formData.mensaje}
                    onChange={handleChange}
                    required
                    rows="5"
                    className="w-full px-4 py-3 rounded-xl border-2 border-gray-200 focus:border-brand focus:outline-none transition-all duration-200 text-gray-900 placeholder-gray-500 font-medium resize-none"
                    placeholder="Cuéntanos más sobre tu proyecto..."
                  ></textarea>
                </div>

                <button
                  type="submit"
                  className="w-full flex items-center justify-center gap-2 px-8 py-4 bg-gradient-to-r from-brand to-yellow-500 text-gray-900 font-bold text-lg rounded-xl hover:from-brand-dark hover:to-yellow-600 shadow-lg hover:shadow-xl hover:shadow-brand/30 transition-all duration-300 hover:scale-[1.02] active:scale-[0.98]"
                >
                  <Icon.Send />
                  Enviar Mensaje
                </button>

                {enviado && (
                  <div className="flex items-center gap-3 p-4 rounded-xl bg-green-50 border-2 border-green-500 text-green-700 font-bold animate-in">
                    <Icon.Check className="text-green-500" />
                    ¡Mensaje enviado exitosamente!
                  </div>
                )}
              </form>
            </div>

            {/* Why Contact Us */}
            <div className="flex flex-col justify-center">
              <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-8">
                ¿Por qué contactarnos?
              </h2>

              <div className="space-y-6">
                {[
                  {
                    title: "Expertos Verificados",
                    desc: "Nuestro equipo está compuesto por profesionales con años de experiencia en consultoría académica."
                  },
                  {
                    title: "Respuesta Rápida",
                    desc: "Respondemos a tus consultas en menos de 72 horas. La rapidez es uno de nuestros sellos distintivos."
                  },
                  {
                    title: "Soluciones Personalizadas",
                    desc: "Cada proyecto es único. Diseñamos soluciones específicas según tus necesidades académicas."
                  },
                  {
                    title: "Confidencialidad Garantizada",
                    desc: "Tu privacidad y confidencialidad son prioridad. Todos los datos se manejan bajo estrictas normas."
                  },
                  {
                    title: "Precio Competitivo",
                    desc: "Ofrecemos la mejor relación calidad-precio del mercado sin comprometer la excelencia."
                  }
                ].map((item, idx) => (
                  <div key={idx} className="flex gap-4 group">
                    <div className="flex-shrink-0 w-6 h-6 rounded-full bg-gradient-to-br from-brand to-yellow-500 flex items-center justify-center text-white mt-1 group-hover:shadow-lg group-hover:shadow-brand/30 transition-all">
                      <Icon.Check className="w-4 h-4" />
                    </div>
                    <div>
                      <h3 className="font-bold text-gray-900 group-hover:text-brand transition-colors">
                        {item.title}
                      </h3>
                      <p className="text-gray-600 text-sm leading-relaxed">
                        {item.desc}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 sm:py-20 lg:py-24 bg-gradient-gold text-center">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-black text-gray-900 mb-6">
            ¿Aún tienes dudas?
          </h2>
          <p className="text-xl sm:text-2xl text-gray-700 mb-8 max-w-2xl mx-auto">
            Haz clic en el botón de WhatsApp y chatea directamente con nuestro equipo.
          </p>
          <a
            href="https://wa.me/+51983318651?text=Hola, quiero información sobre los servicios de Tesis 1 Consultoria"
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-3 px-8 py-4 bg-gradient-to-r from-green-500 to-green-600 text-white font-bold text-lg rounded-xl hover:from-green-600 hover:to-green-700 shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-[1.05] active:scale-[0.95]"
          >
            <svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.297-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.626.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347"/>
            </svg>
            Chatear por WhatsApp
          </a>
        </div>
      </section>
    </div>
  );
}
